import { Component, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Subscription, take, finalize } from 'rxjs';
import { AuthService } from 'src/app/modules/services/auth/auth.service';
import { PageSizeService } from 'src/app/modules/services/page-size/page-size.service';
import { ProjetosService } from 'src/app/modules/services/projetos/projetos.service';
import { UserService } from 'src/app/modules/services/user/user.service';
import { ModalFiltersComponent } from 'src/app/modules/shared/modals/modal-filters/modal-filters.component';
import { ModalHistoricComponent } from 'src/app/modules/shared/modals/modal-historic/modal-historic.component';
import { FeriadoService } from 'src/app/modules/services/feriado/feriado.service';
import { ModalCloneFeriadoComponent } from 'src/app/modules/shared/modals/modal-clone-feriado/modal-clone-feriado.component';
import { AlertComponent } from '../../../alert/alert.component';
import { LoadingService } from '../../../loading/loading.service';
import { ModalComponent } from '../../../modal/modal.component';

@Component({
  selector: 'app-list-feriados',
  templateUrl: './list-feriados.component.html',
  styleUrls: ['./list-feriados.component.scss']
})
export class ListFeriadosComponent {
 @Input() cnpj: any;
  @Input() buttonInclusaoDisabled: boolean = false;
  @Input() buttonExclusaoDisabled: boolean = false;
  @Input() buttonEdicaoDisabled: boolean = false;
  screenWidth: number = 0;
  screenHeight: number = 0;

  // === TABELA: Documentos Assinados ===
  sortState = {
    sortProperty: 'criadoEm',
    sortDirection: 'desc'
  };
  filterParametro:string = '';
columnConfig = [
  { columnDef: 'dataInicio', header: 'Data', property: 'dataInicio', customTd: true },
  { columnDef: 'descricao', header: 'Descrição', property: 'descricao' },
  { columnDef: 'tipoFeriado', header: 'Tipo', property: 'tipoFeriado.descricao' },
  { columnDef: 'recorrente', header: 'Recorrente', property: 'recorrente', customTd: true  },
  { columnDef: 'actions', header: '', custom: true }
];
    subsctiptions: Subscription[] = [];
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = [];
  pageIndex = 0;
  pageSize = 10;
  totalPages = 1;
  totalElements = 0;
   dataAction:any;
  idRelatorio: any;
  criterios: any = [];
  criteriosLabels!: { [key: string]: string; };
  formFeriados!: FormGroup;
  filterData:any;
  filterText:string = "";
  // === CONSTRUTOR ===
  constructor(
    private feriadoService: FeriadoService,
    private _snackBar: MatSnackBar,
    private loadingService: LoadingService,
    private pageSizeService: PageSizeService,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private authService: AuthService,
    private userService: UserService,
    private router: Router,
     private modalCtrl: ModalController,
  ) { }
  ngOnInit(): void {
    this.displayedColumns = this.columnConfig.map(col => col.columnDef);
    this.getData();
     this.formFeriados = this.fb.group({
      anos:[],
    });
    this.buildCriteriosLabels();
  }
  private buildCriteriosLabels() {
    this.criteriosLabels = {
      anos: 'Anos',
    };
  }
    loadUserInfo() {
    const userId = this.authService.getUserIdFromToken();
    if (userId) {
      this.userService.getMenuUsuario(userId).subscribe((response: any) => {
        const functionalities = response.profileUser.permissaoPerfis;

        functionalities.forEach((permission: any) => {
          this.checkFunctionality(permission.funcionalidade);
        });
      });
    }
  }

  checkFunctionality(functionality: any) {

    if (functionality.url === '/feriados') {
      this.handleRestrictions(functionality.restricoes);
    }

    if (functionality.subFuncionalidades && functionality.subFuncionalidades.length > 0) {
      functionality.subFuncionalidades.forEach((subFunctionality: any) => {
        this.checkFunctionality(subFunctionality);
      });
    }
  }

  handleRestrictions(restrictions: any[]) {
    restrictions.forEach((restriction: { nome: any; }) => {
      switch (restriction.nome) {
        case 'Inclusão':
          this.buttonInclusaoDisabled = true;
          break;
        case 'Exclusão':
          this.buttonExclusaoDisabled = true;
          break;
        case 'Edição':
          this.buttonEdicaoDisabled = true;
          break;
      }
    });
  }
    /** Navegar para criação de novo serviço */
  create(): void {
    this.router.navigate([`create-feriado`]);
  }

  // Requisição da aferição inicial
  getData(pageIndex: number = 0): void {
    this.feriadoService
      .getFeriados(
        this.pageSize,
        pageIndex,
        this.sortState.sortDirection,
        this.sortState.sortProperty,
        this.filterParametro,
        this.filterData
      )
      .pipe(
        take(1),
        finalize(() => this.loadingService.hideLoading())
      )
      .subscribe({
        next: (res: any) => {
          const {
            content,
            pageSize,
            totalPages,
            totalElements,
            pageNumber
          } = res;

          this.dataSource.data = content;
          this.pageSize = pageSize;
          this.totalPages = totalPages;
          this.totalElements = totalElements;
          this.pageIndex = pageNumber;
        },
        error: (erro: any) => this.handleRequestError(erro)
      });
  }
  // === ORDENAÇÃO ===
  onSortChange(sortProperty: string): void {
    if (this.sortState.sortProperty === sortProperty) {
      this.sortState.sortDirection =
        this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortState.sortProperty = sortProperty;
      this.sortState.sortDirection = 'asc';
    }

    // Requisição pode ser disparada aqui se necessário
    this.getData(0);
  }
  // === PAGINAÇÃO ===
  pageChangeEvent(event: PageEvent): void {
    const { pageIndex, pageSize } = event;

    if (this.pageSize !== pageSize) {
      this.pageSize = pageSize;
      this.pageSizeService.setPageSize(pageSize);
      this.getData(0);
      return;
    }

    if (this.pageIndex !== pageIndex) {
      this.getData(pageIndex);
    }
  }

  // Tratamento centralizado de erros de requisição
  private handleRequestError(erro: any): void {
    if (erro.status !== 500 && erro.status) {
      this.openSnackBar(erro.error.message, 'error');
    } else if (erro.error?.error === 'Unprocessable Entity') {
      this.openSnackBar(erro.error.message, 'warning');
    } else {
      this.openSnackBar(
        'Sistema indisponível. Estamos trabalhando para resolver. Por favor, tente novamente mais tarde.',
        'error'
      );
    }
  }
  // === SNACKBAR DE ALERTA ===
  openSnackBar(description: string, type: string): void {
    const classMap: Record<string, string> = {
      sucess: 'snacbar-sucess',
      warning: 'snacbar-warning',
      error: 'snacbar-error'
    };

    const classSnack = classMap[type] || 'snacbar-default';

    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description, type },
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }
  redirectToEditPage(id: number): void {
    this.router.navigate([`edit-feriado/${id}`]);
  }

  openDeleteDialog(id: number): void {
       const modalTitle: string = 'Excluir';
        const modalContent: string =
          'Você tem certeza que deseja excluir este Feriado?';
    
        const dialogRef = this.dialog.open(ModalComponent, {
          data: {
            onPerformAction: this.onDeleteModalConfirm.bind(this),
            modalTitle: modalTitle,
            modalContent: modalContent,
            id: id,
          },
        });
  }
  onDeleteModalConfirm(id: any): void {
    this.loadingService.showLoading();

    this.subsctiptions.push(
      this.feriadoService.deleteFeriado(id).pipe(
        finalize(() => {
          this.loadingService.hideLoading();
        })
      ).subscribe({
        next: (resp: any) => {
          this.openSnackBar('Feriado deletado com sucesso.', 'sucess');
           this.getData();
        }, error: (err: any) => {
          this.openSnackBar(err.error.message, 'error');
        }
      })

    );
  }
    redirectToDetailPage(id: number): void {
    this.router.navigate([`detail-projeto/${id}`]);
  }
  async openDialogHistoricoProjeto(id: number) {
      const data = {
            type: 'feriados',
            id: id,
            fieldMappings: {
                descricao: 'Descrição',
                tipoFeriado: 'Tipo de feriado',
                dataInicio: 'Data início',
                dataFim: 'Data fim',
                recorrente: 'Recorrente',
            }
          }
          const modal = await this.modalCtrl.create({
            component: ModalHistoricComponent,
            componentProps: {
              data: data,
              fieldMappings: data.fieldMappings,
            },
          });
      
          modal.present();
    }
    applyFilter(filterValue: string) {
    this.filterParametro = filterValue;
    this.getData();
  }
  openModalFilters(popover?: any) {
  
    let props;
    if(this.filterData ){
      props = this.filterData;
    }else{
      props = this.generatePropsFromForm(this.formFeriados);
    }
  
    const data = {
      type: 'feriados',
      propsFeriados: props,
    };
  
    const dialogRef = this.dialog.open(ModalFiltersComponent, {
      panelClass: ['filter-panel'],
      data,
    });
  
    dialogRef.afterClosed().subscribe({
      next: (data: any) => {
        if (data) {
          this.filterData = data;
          this.criterios = this.getCriterios(data);
          this.getData();
        }
      }
    });
  }
  
  // Função para gerar o objeto props de forma dinâmica a partir dos valores do formulário
  private generatePropsFromForm(form: FormGroup): any {
    const props: any = {};
    // Itera sobre os controles do FormGroup
    Object.keys(form.controls).forEach((controlName: string) => {
      const control = form.get(controlName);
  
      // Verifica se o controle tem valor e não é nulo ou vazio
      if (control && control.value !== null && control.value !== undefined && control.value !== '') {
        props[controlName] = control.value;
      }
    });
    return props;
  }
  
  getCriterios(data: any) {
    const criterios = [];
  
    // Gera os critérios de forma dinâmica, verificando os valores dos campos
    const props: any = this.generatePropsFromForm(data);
  
    for (const prop in props) {
      if (props[prop] !== null && props[prop] !== undefined && props[prop] !== '') {
        criterios.push(prop);
      }
    }
  
    return criterios;
  }
  criterioRemoved(event:any){


    // Lógica para remover da lista de critérios, se necessário
    this.filterData.patchValue({
      [event.criterio]: null
    });
    this.criterios = this.criterios.filter((c:any) => c !== event.criterio);
    this.getData();
  }

  back(){
    this.router.navigate([`home`]);
  }

openCloneModal() {
  const dialogRef = this.dialog.open(ModalCloneFeriadoComponent, {
    width: '650px',   
    maxWidth: '95vw',    
    maxHeight: '90vh',   
    panelClass: 'custom-modal-box', 
    data: {}
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      this.getData(0);
    }
  });
}

}
